// src/MySales.js
import React, { useEffect, useState } from "react";
import { database, ref, onValue } from "./firebase";
import { useNavigate } from "react-router-dom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "./BillingSystem.css";

export default function MySales() {
  const [summary, setSummary] = useState({});
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const navigate = useNavigate();

  const salesmanPhone = localStorage.getItem("phone");
  const salesmanName = localStorage.getItem("name") || "Salesman";

  // ✅ Local product short-name mapping
  const productNamesMap = {
    "Premium 1 Litre": "Pink 1L",
    "Green 1 Litre": "Green 1L",
    "Premium 500ML Bottle": "Pink 500ml",
    "Green 500ML Bottle": "Green 500ml",
    "Premium 250ML Bottle": "Pink 250ml",
    "Premium 2 Litre Bottle": "Pink 2L",
  };

  useEffect(() => {
    if (!salesmanPhone) {
      setSummary({});
      return;
    }

    const invoicesRef = ref(database, `salesmanInvoices/${salesmanPhone}`);
    onValue(invoicesRef, (snap) => {
      if (!snap.exists()) {
        setSummary({});
        return;
      }

      const invoices = Object.values(snap.val());
      const today = new Date().toISOString().split("T")[0];

      const totals = {};
      invoices.forEach((inv) => {
        const invDate = inv.date ? inv.date.split("T")[0] : null;

        // ✅ Date filter
        if (from && invDate < from) return;
        if (to && invDate > to) return;

        // ✅ Default = today's sales
        if (!from && !to && invDate !== today) return;

        inv.items?.forEach((item) => {
          if (!totals[item.product]) {
            totals[item.product] = { cartons: 0, scheme: 0 };
          }
          totals[item.product].cartons += item.quantity || 0;
          totals[item.product].scheme += item.scheme || 0;
        });
      });

      setSummary(totals);
    });
  }, [salesmanPhone, from, to]);

  if (!salesmanPhone) {
    return (
      <div className="page">
        <h2>My Sales</h2>
        <p>No salesman found. Please login again.</p>
        <button onClick={() => navigate(-1)}>Back</button>
      </div>
    );
  }

  const chartData = Object.entries(summary).map(([product, val]) => ({
    product: productNamesMap[product] || product, // ✅ show short name
    cartons: val.cartons,
    scheme: val.scheme,
  }));

  return (
    <div className="container">
      <h2>📊 My Sales - {salesmanName}</h2>

      {/* Date filters */}
      <div style={{ marginBottom: "10px" }}>
        <label>From: </label>
        <input
          type="date"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          style={{ marginRight: "10px" }}
        />
        <label>To: </label>
        <input
          type="date"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          style={{ marginRight: "10px" }}
        />
      </div>

      {chartData.length === 0 ? (
        <p>No sales data.</p>
      ) : (
        <>
          {/* Table */}
          <table border="1" cellPadding="5" style={{ borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr>
                <th>Product</th>
                <th>Cartons</th>
                <th>Scheme</th>
              </tr>
            </thead>
            <tbody>
              {chartData.map((row, i) => (
                <tr key={i}>
                  <td>{row.product}</td>
                  <td>{row.cartons}</td>
                  <td>{row.scheme}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Graph */}
          <h3>📊 Cartons Graph</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData}>
              <XAxis dataKey="product" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="cartons" fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </>
      )}

      <button onClick={() => navigate(-1)}>Back</button>
    </div>
  );
}
